import type { Translation } from '@uefadigital/panenka';
import type { ColDef, IRowNode } from 'ag-grid-community';
import type { HTMLAttributeAnchorTarget } from 'react';

import type { Enum } from './enum.types';
import type { Group, Match, Round, RoundPhase, Team } from './match.types';

export type FormGuide = {
  matches: Match[];
  teamId: string;
};

export const StandingStatus = {
  LIVE: 'LIVE',
  OFFICIAL: 'OFFICIAL',
  FINISHED: 'FINISHED',
} as const;
export type StandingStatus = Enum<typeof StandingStatus>;

export const StandingTrend = {
  UP: 'UP',
  DOWN: 'DOWN',
  EQUAL: 'EQUAL',
} as const;
export type StandingTrend = Enum<typeof StandingTrend>;

export type Standing = {
  drawn: number;
  formguide?: FormGuide;
  goalDifference: number;
  goalsAgainst: number;
  goalsFor: number;
  isLive: boolean;
  lost: number;
  played: number;
  points: number;
  qualified: boolean;
  qualificationLabelId?: string;
  rank: number;
  rankTrend: StandingTrend;
  team: Team;
};

export type QualificationLabel = {
  labelId: string;
  translations?: {
    labelName: Translation;
  };
};

export type GroupStanding = {
  group: Group;
  items: Standing[];
  round: Round;
  status: StandingStatus;
  qualificationLabels?: QualificationLabel[];

  // domestic fields
  name?: string;
  startDate?: string;
  endDate?: string;
  numOrder?: number;
  seasonYear?: string;
};

export type StandingsOptions = {
  cup: string;
  season: string;
  phase?: RoundPhase;
  groupId?: string;
  roundId?: string;
  isDomestic?: boolean;
  columns: ColDef[];
  enableFormguide?: boolean;
  enableFormguidePopover?: boolean;
  enableMatches?: boolean;
  enableSorting?: boolean;
  enableTeamLink?: boolean;
  teamLinkTarget?: HTMLAttributeAnchorTarget;
  isClub: boolean;
  showNotLiveLabel?: boolean;
  provisionalStandings?: boolean;
  newTableFormat?: boolean;
  splitTablePlaces?: boolean;
  procedureUrl?: string;
  procedureUrlText?: string;
  removeHeading?: boolean;
  enableLegend?: boolean;
  hideQualified?: boolean;
  enableCollapse?: boolean;
  teamIds?: string[];
  tracking?: Record<string, string>;
  enableRanking?: boolean;
  enableTrend?: boolean;
  enableCarousel?: boolean;
  carouselTitle?: string;
  carouselBtnLink?: string;
  carouselBtnLabel?: string;
  showSimulatorPromotion?: boolean;
  onRowHover?: (row: IRowNode<Standing>) => void;
};
